import React from "react"

const GuestListSkeleton = () => {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-between gap-4 mt-4 animate-pulse rounded-xl"
          style={{
            animationDelay: `${index * 0.2}s`,
            animationFillMode: "both",
          }}
        >
          {/* Avatar or Icon Placeholder */}
          <div className="w-12 h-12 rounded-full bg-white/10" />

          {/* Text Content Skeleton */}
          <div className="flex-1 flex flex-col gap-2">
            <div className="h-4 bg-white/20 rounded w-6/12" />
            <div className="h-4 bg-white/10 rounded w-9/12" />
          </div>

          {/* Right Side Button / Action Skeleton */}
          <div className="w-16 h-6 bg-white/10 rounded" />
        </div>
      ))}
    </>
  )
}

export default GuestListSkeleton
